import { createAction } from "redux-act";

const BASE_STR = "SURFACE_DEFAULTS";
export const FETCH_COMPANY_LIST_DATA = `${BASE_STR}_FETCH_COMPANY_LIST_DATA`;
export const FETCH_COMPANY_LIST_SUCCESS = `${BASE_STR}_FETCH_COMPANY_LIST_SUCCESS`;
export const FETCH_COMPANY_LIST_FAILED = `${BASE_STR}_FETCH_COMPANY_LIST_FAILED`;

export const CLEAR_FILTERED_LOCATION_LIST = "CLEAR_FILTERED_LOCATION_LIST";
export const FETCH_FILTERED_LOCATION_LIST_DATA = `${BASE_STR}_FETCH_FILTERED_LOCATION_LIST_DATA`;
export const FETCH_FILTERED_LOCATION_LIST_SUCCESS = `${BASE_STR}_FETCH_FILTERED_LOCATION_LIST_SUCCESS`;
export const FETCH_FILTERED_LOCATION_LIST_FAILED = `${BASE_STR}_FETCH_FILTERED_LOCATION_LIST_FAILED`;

export const VALIDATE_SURFACE_DEFAULTS_REQUEST = `${BASE_STR}_VALIDATE_SURFACE_DEFAULTS_REQUEST`;
export const VALIDATE_SURFACE_DEFAULTS_SUCCESS = `${BASE_STR}_VALIDATE_SURFACE_DEFAULTS_SUCCESS`;
export const VALIDATE_SURFACE_DEFAULTS_FAILED = `${BASE_STR}_VALIDATE_SURFACE_DEFAULTS_FAILED`;
export const SET_SURFACE_DEFAULTS_VALIDATION_CONFIRM = `${BASE_STR}_SET_VALIDATION_CONFIRM`;

export const clearFilteredLocationList = createAction(CLEAR_FILTERED_LOCATION_LIST);
export const fetchCompanyList = createAction(FETCH_COMPANY_LIST_DATA);
export const fetchCompanyListSuccess = createAction(FETCH_COMPANY_LIST_SUCCESS);
export const fetchCompanyListFailed = createAction(FETCH_COMPANY_LIST_FAILED);

export const fetchFilteredLocationList = createAction(
    FETCH_FILTERED_LOCATION_LIST_DATA,
    (userGuid) => userGuid
);
export const fetchFilteredLocationListSuccess = createAction(FETCH_FILTERED_LOCATION_LIST_SUCCESS);
export const fetchFilteredLocationListFailed = createAction(FETCH_FILTERED_LOCATION_LIST_FAILED);

export const validateSurfaceDefaultsRequest = createAction(
    VALIDATE_SURFACE_DEFAULTS_REQUEST,
    (payload) => payload
);
export const validateSurfaceDefaultsSuccess = createAction(VALIDATE_SURFACE_DEFAULTS_SUCCESS);
export const validateSurfaceDefaultsFailed = createAction(VALIDATE_SURFACE_DEFAULTS_FAILED);
export const setSurfaceDefaultsValidationConfirm = createAction(
    SET_SURFACE_DEFAULTS_VALIDATION_CONFIRM,
    (showConfirm) => showConfirm
);
